// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const TeamsTabCreatePlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "teamstab-createplanmodalcontainer" */ "./TeamsTabCreatePlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.TeamsTabCreatePlanModalContainer
        };
    });
export const LazyTeamsTabCreatePlanModalContainer = /*#__PURE__*/ lazy(TeamsTabCreatePlanModalContainerLazyLoader);
